import { render, staticRenderFns } from "./HeadItem.vue?vue&type=template&id=773d8472&scoped=true"
import script from "./HeadItem.vue?vue&type=script&lang=js"
export * from "./HeadItem.vue?vue&type=script&lang=js"
import style0 from "./HeadItem.vue?vue&type=style&index=0&id=773d8472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773d8472",
  null
  
)

export default component.exports